import React from "react";
import { Tooltip } from "@mui/material";
import NewRequotedProductDetailsModal from "./NewRequotedProductDetailsModal";

const TOOLTIP_SX = {
  tooltip: {
    sx: {
      backgroundColor: "#1f1d24",
      color: "#fff",
      maxWidth: 300,
      borderRadius: "10px",
      padding: "12px 14px",
      fontSize: 13,
      lineHeight: 1.45,
      textAlign: "left",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.18)",
    },
  },
  arrow: { sx: { color: "#1f1d24" } },
};

// Hourglass for extra information on its way, circling arrows for a re-quote.
const ICONS = {
  extra: "M7 3h10M7 21h10M8 3c0 5 8 5 8 9s-8 4-8 9M16 3c0 5-8 5-8 9s8 4 8 9",
  requote: "M20 11a8 8 0 0 0-14.3-4.9L4 8M4 4v4h4M4 13a8 8 0 0 0 14.3 4.9L20 16M20 20v-4h-4",
};

function StatusBadge({ kind }) {
  const requote = kind === "requote";
  return (
    <span
      role="img"
      aria-label={requote ? "Re-quote requested" : "Extra information requested"}
      style={{
        display: "inline-grid",
        placeItems: "center",
        width: 30,
        height: 30,
        borderRadius: "50%",
        background: requote ? "#f3eefc" : "#fff4d6",
        color: requote ? "#4f2498" : "#a26a00",
        boxShadow: `0 0 0 1px ${requote ? "#e2d6fa" : "#f5dfa3"}`,
        cursor: "help",
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={ICONS[kind]} />
      </svg>
    </span>
  );
}

function RequoteNote({ product }) {
  const comments = product?.quality_check_comments || [];
  const note = comments[comments.length - 1]?.message || product?.quotation_request?.additional_notes?.client_note;
  return (
    <div>
      <strong style={{ display: "block", marginBottom: 4 }}>Re-quote requested</strong>
      {note && <span style={{ display: "block", opacity: 0.85, marginBottom: 6 }}>“{note}”</span>}
      <span style={{ opacity: 0.7 }}>We'll check if we are able to re-quote. This can take up to 48 hours.</span>
    </div>
  );
}

function ExtraNote() {
  return (
    <div>
      <strong style={{ display: "block", marginBottom: 4 }}>Extra information on its way</strong>
      <span style={{ opacity: 0.8 }}>
        We're asking the factory for the information you requested. Depending on how fast they reply, this can take up to
        48 hours.
      </span>
    </div>
  );
}

export default function ProductDetailsTooltip({ product }) {
  const requote = product?.requote_type === "quality_check";
  return (
    <div>
      {product?.requote_request === "SENT" ? (
        <Tooltip componentsProps={TOOLTIP_SX} title={requote ? <RequoteNote product={product} /> : <ExtraNote />} placement="top" arrow>
          <span tabIndex={0} style={{ display: "inline-flex", marginTop: 5, outline: "none" }}>
            <StatusBadge kind={requote ? "requote" : "extra"} />
          </span>
        </Tooltip>
      ) : (
        product?.requote_request === "APPROVED" && product?.status === "accepted" && <NewRequotedProductDetailsModal product={product} />
      )}
    </div>
  );
}
